import { z } from 'zod';

/**
 * Rewards: the daily check-in and playtime pay. Both are collected by the
 * player (a popup on login and a red badge on the Kaki Dollars sign), not
 * paid automatically.
 */
export const rewardsClientMessageSchema = z.discriminatedUnion('t', [
  z.object({ t: z.literal('rewards:claim'), kind: z.enum(['daily', 'playtime']) }),
]);

export const rewardsStateSchema = z.object({
  daily: z.object({
    /** Guests cannot collect the daily check-in. */
    eligible: z.boolean(),
    /** Can be collected right now. */
    available: z.boolean(),
    /** Consecutive days collected so far (0 once a day has been missed). */
    streak: z.number().int(),
    /** What collecting pays now (if available), otherwise what tomorrow pays. */
    amount: z.number().int(),
    /** What the day after that pays, for the "come back tomorrow" hint. */
    nextAmount: z.number().int(),
  }),
  playtime: z.object({
    /** Guests do not earn playtime pay. */
    eligible: z.boolean(),
    claimableBlocks: z.number().int(),
    /** Money waiting to be collected. */
    amount: z.number().int(),
    /** Payouts already collected today. */
    claimedBlocks: z.number().int(),
    blockMoney: z.number().int(),
    blockMs: z.number().int(),
    /** Active time toward the next payout. */
    progressMs: z.number().int(),
  }),
});

export const rewardsServerMessageSchema = z.discriminatedUnion('t', [
  z.object({ t: z.literal('rewards:state') }).merge(rewardsStateSchema),
]);

export type RewardsClientMessage = z.infer<typeof rewardsClientMessageSchema>;
export type RewardsServerMessage = z.infer<typeof rewardsServerMessageSchema>;
export type RewardsState = z.infer<typeof rewardsStateSchema>;
